/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Of_ContentsInputs */

const sv_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innehållsförteckning`)
};

const en_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table of contents`)
};

/**
* | output |
* | --- |
* | "Table of contents" |
*
* @param {Table_Of_ContentsInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const table_of_contents = /** @type {((inputs?: Table_Of_ContentsInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Of_ContentsInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_table_of_contents(inputs)
	return en_table_of_contents(inputs)
});